<div class="m-b-20 order-details">
  <div class="option">
    <img [src]="defaultImage" alt="" />
    <div class="w-full">
      <h1 id="checkout-product-details-title" class="brandfont-bold t-16 d-block m-t-20 m-b-10">
        @if (productDetails) {
          {{
            productDetails?.title?.indexOf("Upgrade from Studio One") > -1
              ? ("account.upgrade_perpetual_license" | translate)
              : productDetails?.title == "Studio One+ (Annual)" && env.features.hybrid_plan_messaging
                ? ("account.upgrade_to_annual" | translate)
                : productDetails?.title
          }}
        }
        @if (!productDetails) {
          Loading...
        }
      </h1>

      @if (productDetails) {
        <div class="d-flex t-14 justify-content-between">
          <div class="text-left">{{ "account.subtotal" | translate }}</div>
          <div class="text-right bold">
            @if (!checkoutService.scheduleDetails) {
              <span
                [innerHTML]="
                  (checkoutService.priceIncludesDiscount?.regular_price ? checkoutService.priceIncludesDiscount.regular_price : productDetails.price)
                    | currency: checkoutService.activeCurrency.toUpperCase()
                "
              ></span>
            }
            @if (checkoutService.scheduleDetails) {
              <span
                [innerHTML]="
                  (checkoutService.selectedS1PlusPlan == 'monthly' || userService.subDetails?.subscription?.subscription_levels_id == 2 ? 0 : checkoutService.s1PlusPrices.hybrid_upgrade.price)
                    | currency: checkoutService.activeCurrency.toUpperCase()
                "
              ></span>
            }
          </div>
        </div>
        @if (checkoutService.priceIncludesDiscount) {
          <div class="d-flex t-12 justify-content-between">
            <div class="text-left">
              <span class="brandfont-bold">{{ "account.discount" | translate }}</span>
            </div>
            <div class="text-right brandfont-bold c-link-blue">- {{ checkoutService.priceIncludesDiscount.amount_discounted | currency: checkoutService.activeCurrency }}</div>
          </div>
          <div class="t-12">
            <span class="brandfont-black d-block c-link-blue">{{ checkoutService.priceIncludesDiscount.discount_message }}</span>
          </div>
        }
        @if (checkoutService.couponData) {
          <div class="d-flex t-12 justify-content-between">
            <div class="text-left">
              <span class="brandfont-bold">{{ "account.discount" | translate }}</span>
              -
              <button type="button" class="link p-0" (click)="checkoutService.removeCoupon()">Remove</button>
            </div>
            <div class="text-right brandfont-bold c-link-blue">- {{ checkoutService.couponData["coupons-total"] | currency: checkoutService.couponData["charged-currency"].toUpperCase() }}</div>
          </div>
        }
        @if (!checkoutService.couponData && checkoutService.couponApplied && checkoutService.couponApplied.amount_off) {
          <div class="d-flex t-12 justify-content-between">
            <div class="text-left">
              <span class="brandfont-bold">Discount</span>
              -
              <button type="button" class="link p-0" (click)="checkoutService.removeCoupon()">Remove</button>
            </div>
            <div class="text-right brandfont-bold c-link-blue">- {{ checkoutService.couponApplied.amount_off | currency: checkoutService.activeCurrency.toUpperCase() }}</div>
          </div>
        }
        @if (checkoutService.selectedActiveOffer) {
          <div class="t-12">
            <span class="brandfont-black d-block c-link-blue">{{ checkoutService.selectedActiveOffer.display_message }}</span>
          </div>
        }
        <div style="height: 20px">
          @if (checkoutService.taxCalculated && checkoutService.taxCalculated > 0 && !checkoutService.isTaxIncluded) {
            <div class="d-flex t-12 justify-content-between">
              <div class="text-left">Tax</div>
              <div class="text-right bold">
                {{
                  checkoutService.taxCalculated && checkoutService.taxCalculated > 0
                    ? (checkoutService.taxCalculated | currency: checkoutService.activeCurrency.toUpperCase())
                    : (0.0 | currency: checkoutService.activeCurrency.toUpperCase())
                }}
              </div>
            </div>
          }
        </div>
        <hr />
        <div class="d-flex t-14 justify-content-between">
          <div class="text-left">{{ "account.total" | translate }}</div>
          <div class="text-right bold">
            @if (!checkoutService.loadingPrices && !checkoutService.calculatingTax && !checkoutService.applyingCoupon) {
              <span class="bold t-14" data-cy="total-amount-charged">
                {{ checkoutService.total | currency: checkoutService.activeCurrency.toUpperCase() }}
              </span>
            }
            @if (checkoutService.loadingPrices || checkoutService.calculatingTax || checkoutService.applyingCoupon) {
              <fa-icon icon="spinner" [animation]="'spin'"></fa-icon>
            }
            @if (checkoutService.isTaxIncluded && checkoutService.taxCalculated && checkoutService.taxCalculated > 0) {
              <span class="t-12 c-gray d-block text-right">Including {{ checkoutService.taxCalculated | currency: checkoutService.activeCurrency.toUpperCase() }} in tax.</span>
            }
          </div>
        </div>
        @if (checkoutService.currencyIsConverted && !checkoutService.taxCalculated && checkoutService.taxCalculated !== 0) {
          <div class="d-flex t-12 justify-content-between">
            <div class="text-left">&nbsp;</div>
            <div class="text-right bold text-muted font-italic">(Exclusive of VAT/Tax)</div>
          </div>
        }
      }
    </div>
  </div>
</div>
